import React from 'react';
import { AdCampaign, AdCampaignType } from '@/types/ads';

const labelByType: Record<AdCampaignType, string> = {
  VIDEO: 'Video',
  BANNER: 'Cintillo',
  TEXT: 'Texto',
  NEWS_TICKER: 'Noticias',
};

const badgeClassByType: Record<AdCampaignType, string> = {
  VIDEO: 'bg-indigo-100 text-indigo-800 border-indigo-200',
  BANNER: 'bg-fuchsia-100 text-fuchsia-800 border-fuchsia-200',
  TEXT: 'bg-green-100 text-green-800 border-green-200',
  NEWS_TICKER: 'bg-red-100 text-red-800 border-red-200',
};

const AdCampaignTypeBadges: React.FC<{ campaign: AdCampaign }> = ({ campaign }) => {
  const type = campaign.type;
  if (!type) {
    return <span className="text-sm text-gray-500">—</span>;
  }

  return (
    <div className="flex flex-wrap gap-1">
        <span
          key={type}
          className={`inline-flex items-center px-2 py-0.5 rounded-md text-xs border ${badgeClassByType[type]}`}
        >
          {labelByType[type]}
        </span>
    </div>
  );
};

export default AdCampaignTypeBadges;
